import React from "react";
import ShowitNameLogo from "./ShowitNameLogo";
import When from "./utils/When";
import styles from "./LoadingView.module.css";

const LoadingView = ({ message = null, error, className }) => {
  const errType = error === "P" ? " loading page" : error === "S" ? " loading design" : "";

  return (
    <div id="view_app_loading" className={`${styles.viewCentered} ${className || ""}`}>
      <div className={styles.showitNameLogo}>
        <ShowitNameLogo />
      </div>
      <When it={!error}>
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 20 20"
          className="loading-spinner"
        >
          <path d="M10,0C4.5,0,0.5,4.5,0.5,10c0,4.9,4.5,9,9.5,9c-4.4,0-8.5-4.2-8.5-9c0-4.4,4.1-8,8.5-8c0.6,0,1-0.4,1-1C11,0.4,10.6,0,10,0z" />
        </svg>
        <div className={styles.message}>{message}</div>
      </When>
      <When it={error}>
        <When it={typeof error === "string"}>
          <p>{`There's been an error${errType}, please contact support`}</p>
        </When>
        <When it={typeof error !== "string"}>{error}</When>
      </When>
    </div>
  );
};

export default LoadingView;
